/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.service('LoginService', ["$rootScope", function ($rootScope) {
       
       
       var _getData = function()
       {
           return localStorage.getItem("loginData");
       }
       
       var _setData = function(data)
       {
           var jsonData = JSON.stringify(data);
           return localStorage.setItem("loginData", jsonData);
       }
       
       var setToken = function(email, token)
       {
           var data = {email: email, token:token}
            _setData(data)
       }
       var getCredentials = function()
       {
           var data = _getData()
           var jsonData = JSON.parse(data)
           return jsonData
       }

        return {
            getCredentials: getCredentials,
            setToken: setToken
        };

    }]);